import { posthogOptOut } from "@/app/_providers/posthog";
import { logger } from "@utilities/logger";
import { useUser } from "@/app/_providers/user";
import { CookieName } from "@/app/_utilities/cookieKeys";
import { getCookieValue, setCookie } from "@/app/_utilities/cookies";
import { getLocation } from "@/app/_utilities/location";
import { saveCCPAOptOut } from "@/app/_utilities/user";
import { useEffect } from "react";

import { isGPCEnabled } from "./gpc";

export const inPrivacyStates = async () => {
  const location = await getLocation();
  return (
    location.country === "US" &&
    [
      "ca", // California
      "co", // Colorado
      "ct", // Connecticut
      "mt", // Montana
      "or", // Oregon
      "tx", // Texas
      "ut", // Utah
      "va", // Virginia
    ].includes(location.region.toLowerCase())
  );
};

export const optOutCCPA = async (options: { isLoggedIn: boolean; shouldReload: boolean }) => {
  const { isLoggedIn, shouldReload } = options;
  if (isLoggedIn) {
    await saveCCPAOptOut({
      optOutCCPA: true,
    });
  }
  setCookie(CookieName.CCPAOptOut, "true");

  posthogOptOut();
  if (shouldReload) {
    window.location.reload();
  }
};

export const isOptedOutCCPA = () => {
  if (typeof window === "undefined") {
    return false;
  }
  return getCookieValue(CookieName.CCPAOptOut) === "true";
};

export const useHandleCCPA = () => {
  const { userData, isLoggedIn } = useUser();

  useEffect(() => {
    const checkPrivacyAndOptOut = async () => {
      const isInPrivacyState = await inPrivacyStates();
      const inPrivacyStateAndUsingGPC = isInPrivacyState && isGPCEnabled();
      if (!isOptedOutCCPA() && (userData?.ccpa_opt_out || inPrivacyStateAndUsingGPC)) {
        // Note: this causes a refresh on first sign in, or first sign up for that device if the user has opted out on a previous machine
        optOutCCPA({ isLoggedIn, shouldReload: false }).catch(e => {
          logger.error(e instanceof Error ? e : null, "CCPA opt-out failed");
        });
      }
      if (isOptedOutCCPA()) {
        posthogOptOut();
      }
    };
    checkPrivacyAndOptOut().catch(e => {
      logger.error(e instanceof Error ? e : null, "CCPA opt-out failed");
    });
  }, [userData?.ccpa_opt_out, isLoggedIn]);
};
